module.exports = __webpack_public_path__ + "static/img/from2.df505ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/from2.jpg
// module id = 44CI
// module chunks = 1